import React from 'react';

function Contact() {

    return (
    <div>
    <div className = 'Taffel'>
        Zane Payer<br/>
        shoot me an email at:<br/>zane.payer@gmail.com
    </div>
    </div>
    
    )
  }

  export default Contact